module.exports = __webpack_public_path__ + "static/media/ri_hraswo.eae10852.ogg";